"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var getDefaultContent = function getDefaultContent(name) {
  switch (name) {
    case 'card':
      return 'summary_large_image';

    case 'site':
      return '@HubSpot';

    default:
      break;
  }

  return null;
};

var TwitterMeta = function TwitterMeta(_ref) {
  var passedName = _ref.name,
      passedContent = _ref.content;
  var name = "twitter:" + passedName;
  var content = passedContent || getDefaultContent(passedName);
  (0, _invariant.default)(!!content, "TwitterMeta: content required to render " + name + " meta tag");
  return _react.default.createElement("meta", {
    name: name,
    content: content
  });
};

TwitterMeta.propTypes = {
  content: _propTypes.default.string,
  name: _propTypes.default.oneOf(['card', 'site', 'image']).isRequired
};
var _default = TwitterMeta;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/elements/TwitterMeta.js
// module id = 276
// module chunks = 209 210 211 212